import {forEach} from 'lodash';
import moment from 'moment';

import {AVAILABILITY_INTERVAL, DAY_INTERVALS_COUNT} from 'constants/working-hours';
import {WorkingHoursInterval} from 'types';

const getInitialTimelineBars = (): Record<string, number> => {
    const mom = moment().startOf('d');
    const data = {} as Record<string, number>;
    for (let i = 0; i < DAY_INTERVALS_COUNT; i++) {
        const key = mom.format('HH:mm');
        data[key] = 0;
        mom.add(AVAILABILITY_INTERVAL, 'm');
    }
    return data;
};

/*
 * How many users are available in 15m interval starting from the object key
 * {'00:00': 1, '00:15': 2}
 */
export const getUsersWorkingHoursBarData = (intervals: WorkingHoursInterval[], timeZone: string): Record<string, number> => {
    const bars = getInitialTimelineBars();
    const dateMoment = moment().tz(timeZone).startOf('d');

    forEach(intervals, (userInterval) => {
        const fromString = dateMoment.clone().set('h', userInterval.from.hours).set('m', userInterval.from.minutes).format('HH:mm');
        const toString = dateMoment.clone().set('h', userInterval.to.hours).set('m', userInterval.to.minutes).format('HH:mm');

        // if working hours are disabled
        if (fromString === toString) {
            for (const key in bars) {
                bars[key] = bars[key] + 1;
            }
            return false;
        }

        const d = moment().startOf('d');
        let isInsideInterval = false;
        for (let i = 0; i < DAY_INTERVALS_COUNT; i++) {
            const key = d.format('HH:mm');
            if (key === fromString) {
                isInsideInterval = true;
            }

            if (key === toString) {
                isInsideInterval = false;
                continue;
            }

            if (isInsideInterval) {
                bars[key] = bars[key] + 1 ;
            }
            d.add(AVAILABILITY_INTERVAL, 'm');
        }
    });

    return bars;
};